import { render, staticRenderFns } from "./AddIntentSample.vue?vue&type=template&id=6c85eeb2&scoped=true"
import script from "./AddIntentSample.vue?vue&type=script&lang=js"
export * from "./AddIntentSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85eeb2",
  null
  
)

export default component.exports